import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';

import { ButtonTypes } from '@ad-scripts/presentation/components/common/button';
import { Footer } from '@ad-scripts/presentation/components/common/full_page_modal';

import EmbedModal, { ModalSize, Close } from 'src/presentation/components/pages/shared/EmbedModal';
import { Button } from 'src/presentation/components/agent_desktop_components';

export enum ConfirmationModalSize {
  SMALL = ModalSize.DEFAULT,
  MEDIUM = ModalSize.LARGE,
  LARGE = ModalSize.EXTRALARGE,
}

type ConfirmationModalProps = {
  title: string;
  onCancel: Function;
  onOk: Function;
  content: ReactElement;
  modalSize?: ConfirmationModalSize;
  cancelLabel?: string;
  confirmationLabel?: string;
};

// @deprecated use ConfirmOrCancelModal instead
// TODO https://app.shortcut.com/gladly/story/140521/use-confirmorcancelmodal-instead-of-confirmationmodal
const ConfirmationModal: FC<ConfirmationModalProps> = ({
  content,
  onCancel,
  onOk,
  title,
  modalSize,
  confirmationLabel,
  cancelLabel,
}) => (
  <StyledEmbedModal
    title={title}
    content={EmbedModalContent({ content, onCancel, onOk, confirmationLabel, cancelLabel })}
    onCancel={onCancel}
    modalSize={modalSize || ConfirmationModalSize.MEDIUM}
  />
);

type EmailModalContentProps = {
  content: ReactElement;
  onCancel: Function;
  onOk: Function;
  cancelLabel?: string;
  confirmationLabel?: string;
};

const EmbedModalContent: FC<EmailModalContentProps> = ({ content, onCancel, onOk, cancelLabel, confirmationLabel }) => {
  return (
    <>
      <DescriptionContainer data-aid={'confirmationModal-description'}>{content}</DescriptionContainer>
      <StyledFooter>
        <Button data-aid={'confirmationModal-discard'} type={ButtonTypes.TEXT} onClick={onCancel}>
          {cancelLabel || 'Cancel'}
        </Button>
        <Button data-aid={'confirmationModal-confirm'} type={ButtonTypes.PRIMARY} onClick={onOk}>
          {confirmationLabel || 'Ok'}
        </Button>
      </StyledFooter>
    </>
  );
};

const StyledFooter = styled(Footer)`
  justify-content: center;
  padding-bottom: 0;
`;

const DescriptionContainer = styled.div`
  line-height: 162%;
  text-align: center;
`;

const StyledEmbedModal = styled(EmbedModal)`
  .Modal-backdrop {
    background-color: ${p => p.theme.colors.white};
    opacity: 0.8;
    z-index: 10;
  }

  .modalCard-backdrop {
    z-index: 11;
  }

  .modalCard-content {
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.04), 0px 0px 10px rgba(0, 0, 0, 0.06), 0px 0px 80px rgba(0, 0, 0, 0.06);
    padding: 18px 45px;

    ${Close} {
      height: 0;
    }
  }
`;

export default ConfirmationModal;
